module.exports = __webpack_public_path__ + "static/media/Warning_Symbol@3x.7f675f51.png";